import React from 'react';

export default function ClockIcon({color , fill}) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 10 12'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.00009 1H6.00009'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.00003 7L6.50003 5.5'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 11C7.20914 11 9 9.20914 9 7C9 4.79086 7.20914 3 5 3C2.79086 3 1 4.79086 1 7C1 9.20914 2.79086 11 5 11Z'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
